// extracted by mini-css-extract-plugin
export var connectionButton = "_bo-1";
export var connectionButtonFloating = "_bo-2";
export var connectionContainer = "_bo-0";
export var rightPanel = "_bo-6";
export var stepCard = "_bo-3";
export var stepCardSubtitle = "_bo-5";
export var stepCardText = "_bo-4";